
export const SliderBackIcon = ({id, onChange}) => {
    return(

        <svg style={{cursor:'pointer'}} onClick={onChange} id={id} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle className="backCirc" cx="8" cy="8" r="8" id={id} transform="rotate(90 8 8)" fill="#E7F0E2"/>
            <path d="M9 5L6 8L9 11" id={id} stroke="#646262" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}